export default __webpack_public_path__ + "static/media/42.622336a7.png";